import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Button,
  Box,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Download as DownloadIcon,
  PictureAsPdf as PdfIcon,
  Image as ImageIcon,
} from '@mui/icons-material';
import { format } from 'date-fns';

function NewsCard({ news, isPublic = true }) {
  const getFileIcon = (fileType) => {
    if (fileType?.startsWith('image/')) {
      return <ImageIcon />;
    }
    return <PdfIcon />;
  };

  return (
    <Card 
      elevation={0} 
      sx={{ 
        mb: 2,
        border: '1px solid',
        borderColor: 'divider',
        '&:hover': {
          borderColor: '#580100',
          bgcolor: 'rgba(88, 1, 0, 0.02)'
        }
      }}
    >
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
          <Typography 
            variant="h6" 
            sx={{ 
              color: '#580100',
              fontSize: '1rem',
              fontWeight: 600,
              mb: 1
            }}
          >
            {news.title}
          </Typography>
          {news.attachment && (
            <Tooltip title={`Download ${news.attachment.name}`}>
              <IconButton 
                size="small"
                href={news.attachment.url}
                target="_blank"
                download
                sx={{ 
                  color: '#580100',
                  '&:hover': {
                    bgcolor: 'rgba(88, 1, 0, 0.08)'
                  }
                }}
              >
                {getFileIcon(news.attachment.type)}
              </IconButton>
            </Tooltip>
          )}
        </Box>
        
        <Typography 
          variant="body2" 
          sx={{ 
            color: 'text.secondary',
            mb: 2,
            whiteSpace: 'pre-wrap'
          }}
        >
          {news.content}
        </Typography>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography 
            variant="caption" 
            sx={{ 
              color: 'text.secondary',
              display: 'flex',
              alignItems: 'center',
              gap: 1
            }}
          >
            {news.timestamp ? format(new Date(news.timestamp), 'MMM dd, yyyy') : 'Date not available'}
            {news.lastUpdated && new Date(news.lastUpdated) > new Date(news.timestamp) && (
              <span>(Updated: {format(new Date(news.lastUpdated), 'MMM dd, yyyy')})</span>
            )}
          </Typography>
          <Typography 
            variant="caption" 
            sx={{ 
              color: '#580100',
              bgcolor: 'rgba(88, 1, 0, 0.08)',
              px: 1,
              py: 0.5,
              borderRadius: 1,
              textTransform: 'uppercase'
            }}
          >
            {news.category}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
}

export default NewsCard;
